/**
 * A mesh with the files its build reads, loaded through the resource loader: a trail mesh whose
 * `curve` is an ExtResource builds once that file has loaded, and a TextMesh once its font file and
 * the outlines and metrics of that font have.
 */
import { useCallback, useMemo } from 'react';
import { useLoadedFilesAndFonts } from '../useLoadedFilesAndFonts';
import { usePendingWhile } from '../usePendingWhile';
import { isAwaitingFont, primitiveMeshFiles, primitiveMeshFontFiles, primitiveMeshReadsFont, } from './primitivemesh/surface';
import { useSceneFontSettleCount } from '../../r3f/controls/native/text/useSceneFontSettleCount';
export function useResolvableMesh(scoped) {
    const filesPlan = useCallback(() => (scoped ? primitiveMeshFiles(scoped) : []), [scoped]);
    const fontsPlan = useCallback((loadedFont) => (scoped ? primitiveMeshFontFiles(scoped, loadedFont) : []), [scoped]);
    const readsFonts = scoped !== null && primitiveMeshReadsFont(scoped.resource.type);
    const { loadedFile, loadedFont, projectFonts, isLoading } = useLoadedFilesAndFonts(filesPlan, fontsPlan, readsFonts);
    const loaded = useMemo(() => (scoped && !isLoading ? { ...scoped, loadedFile, loadedFont, projectFonts } : null), [scoped, isLoading, loadedFile, loadedFont, projectFonts]);
    const hasFontPending = loaded !== null && isAwaitingFont(loaded);
    // The count moves the render that reads the font again, once its outlines and metrics settle.
    useSceneFontSettleCount(hasFontPending);
    usePendingWhile(hasFontPending);
    return {
        mesh: hasFontPending ? null : loaded,
        isLoading: isLoading || hasFontPending,
    };
}
//# sourceMappingURL=useResolvableMesh.js.map